import React from "react";

export default function Createfee() {
    return (
        <div className="createfee-container my-4">
            <div className="special-header panel-white-all">
                <h4 className="page-title">Create Fee Category</h4>
            </div>

            <div className="card col-md-12">
                <div className="card-body cretecard-body">
          <form>
            <div className="row">
            
              <div className="col-md-6 mb-3">
                <label className="form-label">Category Name<span className="text-danger">*</span>
                </label>
                <input type="text" className="form-control" placeholder="Category Name" />
              </div>

           
              <div className="col-md-6 mb-3">
                <label className="form-label">Category Type <span className="text-danger">*</span>
                </label>
                <select className="form-select">
                  <option> Category Type</option>
                  <option value="fee">Fee</option>
                  <option value="discount">Discount</option>
                  <option value="bonus">Bonus</option>
                  <option value="special fee">Special Fee</option>
                </select>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Amount Type</label>
                <select className="form-select">
                  <option>Select Amount Type</option>
                  <option value="percentage">Percentage</option>
                  <option value="amount">Amount</option>
                </select>
              </div>

        
              <div className="col-md-6 mb-3">
                <label className="form-label">Applicable To</label>
                <select className="form-select">
                  <option>Select Applicable To</option>
                  <option value="all students">All Students</option>
                  <option value="new students">New Students</option>
                  <option value="leaving students">Leaving Students</option>
                  <option value="selected student">Selected Students</option>
                </select>
              </div>
           

            <div className=" d-flex justify-content-end" >
              <button type="submit" className="btn custom-btn">
                Create
              </button>
               </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
